module.exports = __webpack_public_path__ + "static/media/mercedes.6027e50b.png";